import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { getWarehouseByName } from "@tggstore/Services/CommonServices";
import { useContext, useEffect, useState } from "react";
import * as React from "react";
import { css } from "styled-components";

export interface OrderDetailsWarehouseStyles {
    titleText?: TypographyPresentationProps;
    termsText?: TypographyPresentationProps;
    wrapper?: InjectableCss;
}

export const orderWarehouseStyles: OrderDetailsWarehouseStyles = {
    titleText: {
        variant: "h6",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
        `,
    },
};
const styles = orderWarehouseStyles;

const getWarehouse = async (order: OrderModel): Promise<string> => {
    try {
        if (!order.orderLines || order.orderLines.length === 0) {
            throw new Error("Order lines are undefined or empty");
        }
        const warehouseName = order.orderLines[0].warehouse;

        const result = await getWarehouseByName(warehouseName);
        if (result.successful) {
            return result.result.description;
        }
    } catch (error) {
        return "";
    }
    return "";
};

const OrderDetailsWarehouse = () => {
    const { value: order } = useContext(OrderStateContext);
    const [warehouse, setWarehouse] = useState<string>("");

    useEffect(() => {
        if(order){
            getWarehouse(order).then(data =>{
                setWarehouse(data);
            });
        }
    }, [order]);
    
    if (!order || !order.orderLines) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography as="h3" {...styles.titleText}>
                {translate("Warehouse")}
            </Typography>
            <Typography {...styles.termsText}>{warehouse || translate("No Warehouse Found")}</Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsWarehouse,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
